var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { Button } from '../Button';

var FileInput = function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  FileInput.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        children = _props.children,
        buttonConfig = _props.buttonConfig,
        inputConfig = _props.inputConfig;
    var inputId = id || "super sexy id";

    var onClick = function onClick(e) {
      var element = document.getElementById(inputId);
      element.click();
    };

    return React.createElement('div', null, React.createElement(Button, _extends({
      colour: 'ghost'
    }, buttonConfig, {
      onClick: onClick,
      type: 'button'
    }), children), React.createElement('input', _extends({
      id: inputId,
      name: inputId,
      type: 'file'
    }, inputConfig, {
      hidden: true
    })));
  };

  return FileInput;
}(Component);

export default FileInput;